export default class CookieStorage implements Storage {
  private _keys: string[] = [];

  constructor() {
    this._keys = window.document.cookie
      .split('; ')
      .map(v => v.split('=')[0])
      .filter(v => v);
  }

  get length() {
    return this._keys.length;
  }

  clear(): void {
    for (const key of this._keys) {
      this.removeItem(key);
    }
  }

  key(index: number) {
    return this._keys[index];
  }

  removeItem(key: string) {
    window.document.cookie =
      key + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    this._keys = this._keys.filter(k => k !== key);
  }

  setItem(key: string, value?: string, expires = 1 * 24 * 60 * 60 * 1000) {
    const { _keys } = this;
    const date = new Date();
    date.setTime(date.getTime() + expires);
    const expireTime = '; expires=' + date.toUTCString();

    window.document.cookie =
      key + '=' + (value ?? '') + expireTime + '; Path=/';

    !_keys.includes(key) && _keys.push(key);
  }

  getItem(key: string) {
    const value = `; ${window.document.cookie}`;
    const parts = value.split(`; ${key}=`);

    return (
      (parts.length === 2 ? parts.pop()?.split(';').shift() : undefined) ?? ''
    );
  }
}
